import React, { Component } from 'react';

import classes from './StepTwo.module.css';
import strings from '../../../../../assets/localization';
import Button from '../../../../UI/Button/Button';
import Autocomplete from '../../../../UI/AutocompleteInner/Autocomplete';

export default class StepTwo extends Component {
  constructor(props) {
    super(props);
    this.autocomplete = React.createRef();
    this.state = {
      footer: 0,
    };
  }

  componentDidMount() {
    // console.log('STEP 2 DID MOUNT', this.autocomplete.refs.input.refs.input);
    if (!this._validateInput()) {
      this.autocomplete.focus();
    }
    document.addEventListener('keydown', this._handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._handleKeyDown);
  }

  _handleKeyDown = (e) => {
    if (e.keyCode === 13 && this._validateInput()) {
      this.props.goToStep(3);
    }
  };

  _validateInput = () => {
    return this.props.location !== '';
  };

  render() {
    return (
      <div className={classes.StepTwo}>
        <div className={classes.InputWrapper}>
          <div className={classes.LabelText}>
            {strings.EnterYourCityOrLocation}
          </div>
          <Autocomplete
            setRef={(component) => (this.autocomplete = component)}
            // onFocus={this.props.onFocus}
            // onBlur={this.props.onBlur}
            setLocation={this.props.setLocation}
            searchLocation={this.props.searchLocation}
            nbsApiSearchLocation={this.props.nbsApiSearchLocation}
            location={this.props.location}
          />
        </div>
        <div className={classes.Footer}>
          <Button
            disabled={!this._validateInput()}
            clicked={this.props.goToStep.bind(this, 3)}
          >
            {strings.next}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegisterInner/Steps/StepTwo/StepTwo.js